<template>
  <AppHeader>Delivery Intents</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">

    <div class="mt-4 responsive-table">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Date</th>
            <th>1000ml</th>
            <th>500ml</th>
            <th>Raw Milk</th>
          </tr>
        </thead>
        <tbody>

          <tr v-for="intent in data.intents" :key="intent.id">
            <td><b>#{{ intent.id }}</b></td>
            <td>{{ toDate(intent.created_at, true) }}</td>
            <td>{{ toDate(intent.updated_at, true) }}</td>
            <td><b>{{ toDate(intent.date) }}</b></td>
            <td>{{ intent.bottle_1000ml }}</td>
            <td>{{ intent.bottle_500ml }}</td>
            <td>{{ intent.raw_milk }} L</td>
          </tr>

          <tr v-if="data.intents.length == 0">
            <td class="text-xl text-center text-gray-500" colspan="100%">No Subscriptions</td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import mixin from '@/utils/mixin.js';
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';

export default {
  name: 'DeliveryIntents',
  mixins: [ mixin ],
  components: { AppHeader, Loading },
  data() {
    return {
      state: 'loading',
      data: { intents: [] },
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'delivery-intents', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.data = resp.data;
        }
      });
    },
  },

  created() {
    if (!this.$store.state.api_token) this.$router.push('/');
    else this.getData();
  }
}
</script>
